// extracted by mini-css-extract-plugin
export default {"main":"style_main__Sh3w3","left":"style_left__iuS-D","right":"style_right__Lfhfe","head":"style_head__I9Asb","image":"style_image__j1dgB"};